// extracted by mini-css-extract-plugin
export default {"wrap":"NavBar_wrap__N3V1x"};